"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProjectListItem = void 0;

var _ProjectInfoChip = _interopRequireDefault(require("../ProjectInfoChip"));

var _CompanyAvatar = _interopRequireDefault(require("../CompanyAvatar"));

var _components = require("../../../components");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var noop = function noop() {};

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    content: {
      padding: theme.spacing(1)
    },
    contentSection: {
      width: '100%'
    },
    infoNoteContainer: _defineProperty({
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }, theme.breakpoints.down('sm'), {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }),
    divider: {
      backgroundColor: theme.palette.secondary.main,
      height: 3,
      borderRadius: 5,
      width: '30%',
      marginBottom: theme.spacing(2)
    },
    description: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }
  };
});

var ProjectListItem = function ProjectListItem(_ref) {
  var className = _ref.className,
      projectId = _ref.projectId,
      _ref$onProjectSelect = _ref.onProjectSelect,
      onProjectSelect = _ref$onProjectSelect === void 0 ? noop : _ref$onProjectSelect,
      title = _ref.title,
      description = _ref.description,
      companyName = _ref.companyName,
      companyPhotoUrl = _ref.companyPhotoUrl,
      status = _ref.status,
      dueDate = _ref.dueDate,
      amount = _ref.amount,
      props = _objectWithoutProperties(_ref, ["className", "projectId", "onProjectSelect", "title", "description", "companyName", "companyPhotoUrl", "status", "dueDate", "amount"]);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    onClick: function onClick() {
      return onProjectSelect ? onProjectSelect(projectId) : noop();
    },
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 2,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_components.Flex, {
    center: true
  }, /*#__PURE__*/_react.default.createElement(_CompanyAvatar.default, {
    name: companyName,
    photoUrl: companyPhotoUrl
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 8,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentSection
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h4",
    gutterBottom: true,
    className: classes.projectTitle,
    align: "left"
  }, title), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body1",
    align: "left",
    dangerouslySetInnerHTML: {
      __html: description
    },
    className: classes.description
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    sm: 2,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, status && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_ProjectInfoChip.default, null, status)), dueDate && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_ProjectInfoChip.default, null, dueDate)), amount && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_ProjectInfoChip.default, null, amount)))))));
};

exports.ProjectListItem = ProjectListItem;
ProjectListItem.propTypes = {
  projectId: _propTypes.default.string.isRequired,
  onProjectSelect: _propTypes.default.func,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  companyName: _propTypes.default.string,
  companyPhotoUrl: _propTypes.default.string,
  dueDate: _propTypes.default.string,
  status: _propTypes.default.string // amount: PropTypes.string

};
var _default = ProjectListItem;
exports.default = _default;